<template>
    <div class="ScenarioTestSet">
        <!--Header-->
        <div class="display-flex align-center justify-space-between header-page">
            <div class="page-title">
                {{ $f.tc('autoTest') }}
            </div>
            <div class="btn-outline-primary btn-run" @click="goToTest">
                <div class="icon-run mr-6"></div>
                {{ $f.tc('runAll') }}
            </div>
        </div>
        <div class="breadcrumbs-bar">
            <div class="display-flex align-center" style="color: #6a82a5;">
                <router-link class="no-underline" v-if="scenario" :to="`/scenarios/${scenario.id}`">
                    {{ scenario.name }}
                </router-link>
                <div class="px-2">/</div>
                <router-link class="no-underline" v-if="scenario" :to="`/scenarios/${scenario.id}/testsets`">
                    {{ $f.tc('autoTest') }}
                </router-link>
            </div>
        </div>
        <!--Table of test set-->
        <div class="p-20">
            <DataTableCustom
                :headers="headers"
                :items="items"
                @page-change="refresh"
                @row-click="rowClick($event)"
            >
                <template v-slot:numberOfTestCases="props">
                <span class="centerXY">
                    {{ props.item.numberOfTestCases }}
                </span>
                </template>
                <template v-slot:action="props">
                <span class="centerXY">
                    <v-btn icon small class="mx-0">
                            <img src="/img/edit-2.svg" alt="icon-edit" style="transform: scale(0.9);">
                    </v-btn>
                    <v-btn icon small class="mx-0" @click.stop="deleteItem(props.item)">
                            <img src="/img/delete-new.svg" alt="icon-delete" style="transform: scale(0.9);">
                    </v-btn>
                </span>
                </template>
            </DataTableCustom>
        </div>
    </div>
</template>

<script>
import ScenarioService from "@/services/scenario.service";
import DataTableCustom from "@/components/DataTableCustom";
import lodash from "lodash";
import $const from "@/utils/const";

export default {
    name: "ScenarioTestSet",
    components: {DataTableCustom},
    data() {
        return {
            scenario: null,
            testCaseList: [],
            // var for table test set
            items: []
        }
    },
    computed: {
        headers() {
            return this.$appService.correctHeaders([
                {
                    text: this.$t('name'),
                    value: 'group'
                },
                {
                    text: this.$t('numberOfTestCases'),
                    value: 'numberOfTestCases',
                    type: 'custom',
                    textAlign: 'center'
                },
                {
                    text: this.$t('action'),
                    value: 'action',
                    id: 'action',
                    type: 'custom',
                    textAlign: 'center'
                }
            ])
        }
    },
    mounted() {
        this.refresh()
        this.getScenario()
    },
    methods: {
        getScenario() {
            ScenarioService.read(this.$route.params.scenarioId).then(
                result => {
                    this.scenario = result.data
                }
            )
        },
        refresh(pager) {
            if (pager) {
                this.pagination.page = pager
            }
            let scenarioId = this.$route.params.scenarioId
            if (!scenarioId) {
                return
            }
            this.$appService.showLoading()
            ScenarioService.AutomationTestService.search(scenarioId).then(
                result => {
                    let data = result.data
                    let items = []
                    data.forEach(item => {
                        if (!items.find(i => i.group === item.group)) {
                            items.push({
                                ...item,
                                numberOfTestCases: data.filter(i => i.group === item.group).length
                            })
                        }
                    })
                    this.items = items
                },
                this.$appService.handleRequestError()
            ).finally(this.$appService.hideLoading)
        },
        deleteItem(item) {
            this.$appService.confirm(this.$t('confirmDeleteTestSet', {item: item.group}))
                .then(confirm => {
                    if (confirm) {
                        this.$appService.showLoading()
                        ScenarioService.deleteTestSet(this.$route.params.scenarioId, item.group).then(
                            () => {
                                this.refresh()
                            }
                        ).finally(this.$appService.hideLoading)
                    }
                }
            )
        },
        copyItem(item) {
            this.$appService.inputText(this.$filters.capitalize(this.$t('exampleName'))).then(
                name => {
                    ScenarioService.AutomationTestService.create(this.$route.params.scenarioId, {
                        name: name,
                        scenario: this.$route.params.scenarioId,
                        steps: item.steps
                    }).then(
                        () => {
                            this.searchItem()
                        }
                    )
                }
            )
        },
        rowClick(item) {
            this.$router.push(`/scenarios/${this.$route.params.scenarioId}/testsets/${item.group}`)
        },
        goToTest() {
            this.$router.push(`/scenarios/${this.$route.params.scenarioId}/testsets/${$const.RUN_ALL_TESTCASES}`)
        }
    }
}
</script>

<style scoped lang="scss">
.header-page {
    background: #FFFFFF;
    border-bottom: 1px solid #E4EDFA;
    padding: 0 20px;
    flex-wrap: wrap;
    height: 63px;

    .page-title {
        font-family: "open sans bold";
        font-size: 22px;
    }

    .btn-run:hover {
        .icon-run {
            transform: scale(1.15);
        }

        .icon-run:before {
            content: url("/img/scenario/run-test_white.svg") !important;
        }
    }

    .icon-run {
        height: 30px;
        transform: scale(1.05);
        transition: 0.4s;

        &:before {
            content: url("/img/scenario/run-test.svg");
        }
    }
}

.breadcrumbs-bar {
    padding: 0 20px;
    height: 44px;
    display: flex;
    align-items: center;
    background: #FFFFFF;
    border-bottom: 1px solid #E4EDFA;
    font-family: "open sans semi";
    font-size: 16px;
}

::v-deep {
    .pager-wrap {
        display: none !important;
    }

    .v-datatable__progress {
        display: none !important;
    }

    .v-table thead tr:first-child {
        border-bottom: 1px solid #DADFEC !important;
    }

    a {
        color: #6a82a5;
        transition: 0.4s;

        &:hover {
            color: #0052cc;
        }
    }
}
</style>
